module.exports = __webpack_public_path__ + "static/hwroll_1lg-b4889351a75e737728af15945694bc3b.jpg";